import { render, staticRenderFns } from "./ReceiverOrderInfoAttachmentDocs.vue?vue&type=template&id=6e27a3b7&"
import script from "./ReceiverOrderInfoAttachmentDocs.vue?vue&type=script&lang=js&"
export * from "./ReceiverOrderInfoAttachmentDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports